import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="App bg-[#080808] min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-md" data-testid="payment-cancel-page">
        <XCircle className="mx-auto text-[#8A8782]" size={56} />
        <h1 className="font-display font-light text-5xl tracking-tighter mt-6">Checkout cancelled.</h1>
        <p className="text-[#8A8782] text-sm mt-4">Your order is still saved in your cart.</p>
        <button onClick={() => nav("/shop")} className="btn-toxic px-8 py-3 mt-8">Back to Shop</button>
      </div>
    </div>
  );
}
